import * as React from "react";
import styled from "styled-components";
import { SortIcon } from "components/common";
const SortContainer = styled.span`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justtify-content: flex-start;
  gap: 0.3rem;
`;
function ColumnSort({ field, orderBy, direction, onSort, children }) {
  const onChange = () => {
    if (direction === "asc") onSort(field, "desc");
    else onSort(field, "asc");
  };
  return /* @__PURE__ */ React.createElement(SortContainer, null, children, /* @__PURE__ */ React.createElement(
    SortIcon,
    {
      activeDirection: field === orderBy ? direction : null,
      title: `sort-${field}`,
      ascId: "asc",
      descId: "desc",
      onChange
    }
  ));
}
export default ColumnSort;
